'use strict'

import Vue from 'vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import store from '@/store/index'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['Authorization'] = ''
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const request = axios.create({})

request.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    store.state.loading_axios = true
    return config
  },
  error => {
    Promise.reject(error)
  }
)

request.interceptors.response.use(response => {
  store.state.loading_axios = false
  return response
}, async(error) => {

  if (error.response) {
    let data = {}
    let statusCode = 400
    let message = ''
    let string = ''
    if (error.response.data.hasOwnProperty("error")) {
      data = error.response.data.error
      statusCode = error.response.data.error.status_code
      message = error.response.data.error.message
      string = error.response.data.error.message
    } else if (error.response.data.hasOwnProperty("data")) {
      data = error.response.data.data
      statusCode = error.response.data.data.status_code
      message = error.response.data.data.message
      string = error.response.data.data.message
    }

    store.state.loading_axios = false

    if (statusCode === 401) {
      if (store.state.auth_data !== null) {
        if (store.state.auth_data?.auth_by === 'BASIC' || store.state.auth_data?.auth_by === 'SYSTEM') {
          if (store.state.auth_data.refresh_token) {
            const originalRequest = error.config
            originalRequest._retry = true
            const headers = {
              'Authorization': 'Bearer ' + getToken()
            }
            const dataAuth = {
              client_id: process.env.VUE_APP_CLIENT_ID,
              client_secret: process.env.VUE_APP_CLIENT_SECRET,
              grant_type: 'refresh_token',
              refresh_token: store.state.auth_data.refresh_token,
              scope: ''
            }
            return new Promise((resolve, reject) => {
              if (store.state.auth_data?.auth_by === 'BASIC') {
                axios.post('/customer/auth/refreshtoken', dataAuth, { headers: headers }).then(res => {
                  store.dispatch('save_token', res.data)
                  store.state.loading_axios = false
                  error.config.headers['Authorization'] = 'Bearer ' + res.data.access_token
                  return request.request(error.config)
                }).catch(async() => {
                  await store.dispatch('fetchToken')
                  const isRefreshToken = 1
                  reject({
                    statusCode,
                    message,
                    string,
                    data,
                    isRefreshToken
                  })
                })
              } else {
                axios.get('/system/refreshtoken', { headers: headers }).then(res => {
                  store.dispatch('save_token', res.data)
                  store.state.loading_axios = false
                  error.config.headers['Authorization'] = 'Bearer ' + res.data.access_token
                  location.reload()
                  return request.request(error.config)
                }).catch(async() => {
                  console.log('catch error')
                  await store.dispatch('fetchToken')
                  const isRefreshToken = 1
                  reject({
                    statusCode,
                    message,
                    string,
                    data,
                    isRefreshToken
                  })
                })
                // if (process.env.VUE_APP_RESERVATION === 'development') {
                //   window.location.href = '/login'
                // }
              }
            })
          } else {
            store.dispatch('fetchToken')
          }
        } else {
          if (process.env.VUE_APP_RESERVATION === 'development') {
          await store.dispatch('remove_token')
          await store.dispatch('fetchToken')
          }
          // location.reload()
        }
      } else {
        await store.dispatch('fetchToken')
      }
  }


    return Promise.reject({
      data: data,
      statusCode: statusCode,
      message: message,
      string: string,
      res: error.response.data
    })

  }
})

// Plugin.install = function(Vue) {
//   Vue.axios = request
//   window.axios = request
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get() {
//         return request
//       }
//     },
//     $axios: {
//       get() {
//         return request
//       }
//     }
//   })
// }

// Vue.use(Plugin)

// export default Plugin

export default request
